import React from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Paper, Typography } from '@mui/material';
import FAuthOktaUserActivation from '../features/okta-user-activation/FAuthOktaUserActivation';
import langAuthOktaUserActivation from '../features/okta-user-activation/langs/langAuthOktaUserActivation';
import { useTranslation } from 'react-i18next';

const PAuthInvestorUserActivation = () => {
	const routeParams = useParams();

	const { t } = useTranslation();

	return (
		<Grid container spacing={3} alignItems="center" justifyContent="center">
			<Grid item sm={6} className="flex items-center">
				<Paper variant="elevation" style={{ padding: '36px', textAlign: 'center' }}>
					<Typography
						variant="h1"
						component="h1"
						style={{ fontWeight: 600, fontSize: '1.5rem', marginBottom: '24px' }}
					>
						{t(langAuthOktaUserActivation.title_activation.tag)}
					</Typography>

					<FAuthOktaUserActivation activationToken={routeParams.activationToken ?? ''} />
				</Paper>
			</Grid>
		</Grid>
	);
};

export default PAuthInvestorUserActivation;
